import { makeLabels } from 'utils/i18n';

const NAMESPACE = 'page.merchant.sections.kyb.components.modal.settingsSwitch';
export const LABELS = makeLabels(
  {
    LABEL: ['label', 'Complete KYB Information!'],
    TOOLTIP: [
      'tooltip',
      'Turn this off to enter or update only part of the KYB information. None of the fields will be required,' +
        'and your entry will be saved as a partial submission to Bridge.',
    ],
  },
  NAMESPACE,
);

export default LABELS;
